import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@/components/button/Buttons';
import CancelSubscriptionModal, {
  CancelSubscriptionEntityType,
} from '@/components/subscription-management/CancelSubscriptionModal';
import { formatDisplayDate } from '@/utils/Date';

interface EntityCancelPlanButtonProps {
  entityType: CancelSubscriptionEntityType;
  entityId: string;
  entityName?: string;
  planPrice?: number;
  cancellationRequested?: boolean;
  subscriptionEndDate?: string | null;
  onSuccess?: () => void;
  className?: string;
}

const EntityCancelPlanButton: React.FC<EntityCancelPlanButtonProps> = ({
  entityType,
  entityId,
  entityName,
  planPrice = 0,
  cancellationRequested = false,
  subscriptionEndDate,
  onSuccess,
  className,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const canCancel = planPrice > 0 && !cancellationRequested && !!entityId;

  if (!canCancel && !cancellationRequested) {
    return null;
  }

  const endLabel = subscriptionEndDate
    ? formatDisplayDate(new Date(subscriptionEndDate))
    : null;

  return (
    <div className={className}>
      {cancellationRequested && endLabel && (
        <p className="text-sm text-amber-700 mb-3">
          {intl.formatMessage(
            { id: 'SUBSCRIPTION.CANCEL_PLAN.PENDING' },
            { date: endLabel }
          )}
        </p>
      )}
      {canCancel && (
        <Button type="button" variant="danger" onClick={() => setOpen(true)}>
          {intl.formatMessage({ id: 'SUBSCRIPTION.CANCEL_PLAN.CONFIRM' })}
        </Button>
      )}
      <CancelSubscriptionModal
        isOpen={open}
        onClose={() => setOpen(false)}
        entityType={entityType}
        entityId={entityId}
        entityName={entityName}
        subscriptionEndDate={endLabel}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default EntityCancelPlanButton;
